import { theme } from '@pocketlaw/tetris';
import styled, { css } from 'styled-components';
export const Node = styled.li `
  position: relative;
  display: flex;
  flex-direction: column;
`;
export const AlignRight = styled.div `
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;
export const NodeContent = styled.div `
  display: flex;
  align-items: center;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  transition: background-color 150ms ease-in-out;

  ${({ $file }) => $file &&
    css `
      &:hover {
        background-color: ${theme.semantic.surface.sunken};
      }
    `}

  ${({ $folder }) => $folder &&
    css `
      cursor: pointer;

      &:hover {
        background-color: ${theme.swatches.blue[50]};
      }
    `}
`;
